/* -------------------------------------------------- */
/*                       Shapes                       */
/* -------------------------------------------------- */

import {CatalogItemCardShape, DrawShape, FrameShape, ImageShape, SelectedShapesTitleShape} from '@modules/whiteboard/shapes'
import {HighlighterShape} from '@modules/whiteboard/shapes/highlighter'
import {TLBinding, TLHandle, TLShape} from '@tldraw/core'
import {ShapeStyles} from './shared'
import { TextShape } from './text'

export enum Decoration {
  Arrow = 'arrow',
}

export interface IOptionalTitleShapeConfig {
  show?: boolean
  title?: string
}

export interface TDBaseShape extends TLShape {
  style?: Partial<ShapeStyles>
  type: TDShapeType
  handles?: Record<string, TldrawHandle>

  optionalTitle?: IOptionalTitleShapeConfig
}

// The extended handle (used for arrows)
export interface TldrawHandle extends TLHandle {
  canBind?: boolean
  bindingId?: string
}

// The shape created with the arrow tool
export interface ArrowShape extends TDBaseShape {
  type: 'arrow'
  bend: number
  handles?: {
    start: TldrawHandle
    bend: TldrawHandle
    end: TldrawHandle
  },
  decorations?: {
    start?: Decoration
    end?: Decoration
    middle?: Decoration
  }
}

export interface ArrowBinding extends TLBinding {
  handleId?: keyof ArrowShape['handles']
  distance?: number
  point?: number[]
}

export type TDBinding = ArrowBinding | TLBinding

// The shape created by the ellipse tool
export interface EllipseShape extends TDBaseShape {
  type: 'ellipse'
  radius: number[]
}

// The shape created by the rectangle tool
export interface RectangleShape extends TDBaseShape {
  type: 'rectangle'
  size: number[]
}


// The shape created by the sticky tool
export interface StickyShape extends TDBaseShape {
  type: 'sticky'
  size: number[]
  text: string
}

// The shape created when multiple shapes are grouped
export interface GroupShape extends TDBaseShape {
  type: 'group'
  size: number[]
  children: string[]
}

// A union of all shapes
export type TDShape =
  | RectangleShape
  | EllipseShape
  | DrawShape
  | ArrowShape
  | TextShape
  | GroupShape
  | StickyShape
  | CatalogItemCardShape
  | SelectedShapesTitleShape
  | ImageShape
  | FrameShape
  | HighlighterShape

export type TDShapeType = 'sticky'
  | 'ellipse'
  | 'rectangle'
  | 'draw'
  | 'arrow'
  | 'text'
  | 'line'
  | 'group'
  | 'highlighter'
  | WhiteboardShapeType

export type WhiteboardShapeType =
  | 'frame'
  | 'catalogItem'
  | 'selectedShapesTitle'
  | 'image'



// WEBPACK FOOTER //
// ./src/modules/whiteboard/shapes/types.ts